import { createSlice } from "@reduxjs/toolkit";
import { asyncStatus } from "../../utils/asyncStatus";
import { get_all_conversations } from "../../services/ConversationsService";

const initialState = {
  get_conversations_status: asyncStatus.IDLE,
  get_conversations_data: [],
  get_conversations_error: null,
};

const conversationsSlice = createSlice({
  name: "conversations",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get All Conversations
    builder.addCase(get_all_conversations.pending, (state) => {
      state.get_conversations_status = asyncStatus.LOADING;
    });
    builder.addCase(get_all_conversations.fulfilled, (state, { payload }) => {
      state.get_conversations_status = asyncStatus.SUCCEEDED;
      state.get_conversations_data = payload.conversations;
    });
    builder.addCase(get_all_conversations.rejected, (state, action) => {
      state.get_conversations_status = asyncStatus.ERROR;
      state.get_conversations_error = action.error;
    });
  },
});

export default conversationsSlice.reducer;
